import { render, staticRenderFns } from "./historyReview.vue?vue&type=template&id=7fdfb651&scoped=true&"
import script from "./historyReview.vue?vue&type=script&lang=js&"
export * from "./historyReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdfb651",
  null
  
)

export default component.exports